<template>
  <div>
    <el-dialog title="安排司机" :visible.sync="showDialog" append-to-body width="55%" @close="onClose">
      <el-descriptions title="" :column="3" :contentStyle="{ color: '#909399' }">
        <el-descriptions-item label="物流任务ID">{{ formData.logisticsTaskId }}</el-descriptions-item>
        <el-descriptions-item label="订单总数量">{{ planQty }}</el-descriptions-item>
        <el-descriptions-item label="未派车数量">{{ noPlanQty }}</el-descriptions-item>
      </el-descriptions>

      <el-form ref="formDataRef" :model="formData" label-width="130px" inline :rules="rules" style="margin-top:10px" size="mini">
        <el-form-item label="司机名称" prop="name">
          <el-input style="width:170px" disabled v-model="formData.name" />
          <el-button type="primary" @click="onSelect" size="mini" style="margin-left:5px">选择司机</el-button>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input style="width:170px" disabled v-model="formData.mobile" />
        </el-form-item>
        <el-form-item label="身份证号" prop="identityNo">
          <el-input style="width:170px" disabled v-model="formData.identityNo" />
        </el-form-item><br />

        <el-form-item label="车牌号" prop="plateNo">
          <el-input style="width:170px" disabled v-model="formData.plateNo" />
          <el-button type="primary" @click="onSelectVehicle" size="mini" style="margin-left:5px">选择车辆</el-button>
        </el-form-item>
        <el-form-item label="车型" prop="vehicleId">
          <plt-dict-select namespace="logistic" id="vehicleType" disabled v-model="formData.vehicleId" size="mini" style="width:170px" />
        </el-form-item>
        <el-form-item label="装货数量" prop="quantity">
          <el-input-number v-model="formData.quantity" style="width:170px" :max="noPlanQty" controls-position="right" />
        </el-form-item>

        <el-form-item label="预计上门日期" prop="expectedLoadTime">
          <el-date-picker v-model="formData.expectedLoadTime" value-format="yyyy-MM-dd" size="mini" style="width:170px" />
        </el-form-item>

      </el-form>

      <template #footer>
        <el-button @click="onClose" size="mini">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="mini">确定</el-button>
      </template>
      <select-driver ref="selectDriverRef" @onCallback="onFinishSeleDriver" />
      <select-vehicle ref="selectVehicleRef" @onCallback="onFinishSeleVehicle" />

    </el-dialog>
  </div>
</template>

<script>
import selectDriver from "./select-driver.vue";
import selectVehicle from "./select-vehicle.vue";

export default {
  components: { selectDriver, selectVehicle },
  data() {
    return {
      showDialog: false,
      formData: {
        expectedLoadTime: "",
        logisticsTaskId: "",
        plateNo: "",
        driverMemberId: "",
        linkmanId: "",
        name: "",
        vehicleId: "",
        mobile: "",
        identityNo: ""
      },
      noPlanQty: "",
      planQty: "",
      rules: {
        name: [{ required: true, message: "请选择" }],
        quantity: [{ required: true, message: "请输入" }],
        vehicleId: [{ required: true, message: "请选择" }],
        plateNo: [{ required: true, message: "请选择" }],
        expectedLoadTime: [{ required: true, message: "请选择" }],
      }
    };
  },
  methods: {
    openDialog(row) {
      this.formData.logisticsTaskId = row.logisticTaskId;
      this.planQty = row.planQty;
      this.noPlanQty = row.planQty - (row?.subTasks ? row?.subTasks?.reduce((total, item) => (total += item.planQty), 0) ?? 0 : 0);
      this.showDialog = true;
    },
    onClose() {
      this.$refs["formDataRef"].resetFields();
      this.formData.driverMemberId = "";
      this.formData.linkmanId = "";
      this.formData.mobile = "";
      this.formData.identityNo = "";
      this.showDialog = false;
    },
    onSelect() {
      this.$refs["selectDriverRef"].openDialog();
    },
    onSelectVehicle() {
      this.$refs["selectVehicleRef"].openDialog();
    },
    onFinishSeleDriver(params) {
      this.formData.driverMemberId = params.driverId;
      this.formData.linkmanId = params.contactId;
      this.formData.name = params.name;
      this.formData.mobile = params.mobile;
      this.formData.identityNo = params.identityNo;
      this.formData.plateNo = params.plateNo;
      this.formData.vehicleId = params.vehicleId;
    },
    onFinishSeleVehicle(params) {
      this.formData.plateNo = params.plateNo;
      this.formData.vehicleId = params.vehicleId;
    },
    async onSubmit() {
      let validate = await this.$refs["formDataRef"].validate();
      if (!validate) return;
      let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyService/carrierCreateLogisticsSubTask";
      this.cfmInvoke(url, this.formData).then((rs) => {
        this.$message.success("操作成功");
        this.onClose();
        this.$emit("onFinish");
      });
    }
  }
};
</script>